import Collection from './collection.js';
import TimeEntry from 'newModels/time-entry.js';

export default class TimeEntries extends Collection {
    url() {
        if (this.employee) {
            return `${this.employee.url()}/timeEntries`;
        }

        if (this.company) {
            return `${this.company.url()}/timeEntries`;
        }

        return '/TimeEntries';
    }

    initialize(models, {company = null, employee = null}) {
        super.initialize(...arguments);
        this.model = TimeEntry;
        this.searchableAttributes = ['date'];
        if (!this.options.sortKey) {
            this.options.sortKey = 'date';
        }
        this.company = company;
        this.employee = employee;
        return this;
    }

    dirty() {
        return this.reduce((memo, model) => {
            return memo || (
                (model.dirty() && !model.isNew()) ||
                (model.isNew() && model.get('hours'))
            );
        }, false) || (this.removedModels.length > 0);
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/time-entries.js